export default "__VITE_ASSET__BUEwlePe__"